import { useEffect, useState } from "react";
import { getOrderCacheById,postOrderCache,patchOrderCache} from "../../services/OrderCacheServices";
import { getClienteById} from "../../services/ClientesServices";
import { getEmpleadoById} from "../../services/EmpleadosServices";
import { getOrderCacheDetailPanel} from "../../services/OrderCacheDetailServices";
import { PedidosFormContext } from "./PedidosContext";
import { useNavigate, useParams } from 'react-router-dom';

export const PedidosFormState = ({ children }) => {
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (id) getPedidoByIdData(id);
    }, [id]);

    async function getPedidoByIdData(id) {
        try {
            const res = await getOrderCacheById(id);
           return res; 
        } catch (error) {
            console.error("Error al obtener los datos del pedido: ", error);
        }
    }

      const postPedidoData = async (body) => {
            const res = await postOrderCache(body)
            if (res) navigate("/Pedidos");
        }
    
        const patchPedidoData = async (id, body) => {
            const res = await patchOrderCache(id, body)
    
            if (res) navigate("/Pedidos");
        }
    
    
    return (
        <PedidosFormContext.Provider value={{
            getPedidoByIdData,
            postPedidoData,
            patchPedidoData
        }}>
            {children}
        </PedidosFormContext.Provider>
    );
};
